import { useCallback, useMemo } from "react";

import { ReactQuillsProps, removeHtmlTagsAndEntities } from "../../../../../utils";
import { normalizeBoardDocumentContent } from "../utils/boardDocumentUtils";
import { registerBoardDocumentVideoBlot } from "../utils/boardDocumentVideoBlot";

registerBoardDocumentVideoBlot();

export function useBoardDocumentEditor({ isPermission, setSummary }) {
  const modules = useMemo(() => {
    if (!isPermission) {
      return {
        ...ReactQuillsProps.modules,
        toolbar: false,
      };
    }

    return ReactQuillsProps.modules;
  }, [isPermission]);

  const handleChange = useCallback(
    (value) => {
      if (!isPermission) {
        return;
      }

      const normalizedValue = normalizeBoardDocumentContent(value);
      const cleanValue =
        removeHtmlTagsAndEntities(normalizedValue).length === 0
          ? ""
          : normalizedValue;

      setSummary(cleanValue);
    },
    [isPermission, setSummary]
  );

  return {
    modules,
    formats: ReactQuillsProps.formats,
    handleChange,
  };
}
